module.exports = __webpack_public_path__ + "img/hero-bg.5d8f4ae.webp";